"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["NOT_ACTIVATED"] = "NOT_ACTIVATED";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["DISABLED"] = "DISABLED";
    UserStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    UserStatus["DELETED"] = "DELETED";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
//# sourceMappingURL=userStatus.js.map